import { axios, API } from './config';

export const posAPI = {
  // Get drink menu
  getDrinkMenu: () => axios.get(`${API}/pos/drink-menu`),

  // Sessions
  getAllSessions: () => axios.get(`${API}/pos/sessions`),
  getActiveSessions: () => axios.get(`${API}/pos/sessions/active`),
  getSessionsForContract: (contractId) => axios.get(`${API}/pos/sessions/contract/${contractId}`),
  getSession: (sessionId) => axios.get(`${API}/pos/sessions/${sessionId}`),
  createSession: (data) => axios.post(`${API}/pos/sessions`, data),
  closeSession: (sessionId, data) => axios.post(`${API}/pos/sessions/${sessionId}/close`, data),
  getSessionReport: (sessionId) => axios.get(`${API}/pos/sessions/${sessionId}/report`),
  restockInventory: (sessionId, data) => axios.post(`${API}/pos/sessions/${sessionId}/restock`, data),

  // Transactions
  createTransaction: (data) => axios.post(`${API}/pos/transactions`, data),
  getSessionTransactions: (sessionId) => axios.get(`${API}/pos/transactions/session/${sessionId}`),
  voidTransaction: (transactionId) => axios.delete(`${API}/pos/transactions/${transactionId}`),
};

export default posAPI;
